import gql from "graphql-tag";

export const SIGN_OUT = gql`
  mutation signOut {
    signOut {
      status
    }
  }
`;

export const UPDATE_USER_AVATAR = gql`
  mutation updateUserAvatar($avatar: Upload!, $cropParams: CropParamsInput) {
    updateUserAvatar(avatar: $avatar, cropParams: $cropParams) {
      avatar
    }
  }
`;

export const UPDATE_USER_PROFILE_INFO = gql`
  mutation updateProfile(
    $firstName: String
    $lastName: String
    $propertyTypes: [String!]
    $licence: String
    $brokerName: String
    $brokerageAddress: String
    $facebook: String
    $linkedin: String
    $agentSince: String
    $otherLicenses: String
    $specialties: [String!]
    $aboutMe: String
    $businessPhone: String
    $brokeragePhone: String
    $managingBrokerName: String
    $brokerLicenseNumberAndState: String
  ) {
    updateProfile(
      firstName: $firstName
      lastName: $lastName
      propertyTypes: $propertyTypes
      licence: $licence
      brokerName: $brokerName
      brokerageAddress: $brokerageAddress
      facebook: $facebook
      linkedin: $linkedin
      agentSince: $agentSince
      otherLicenses: $otherLicenses
      specialties: $specialties
      aboutMe: $aboutMe
      businessPhone: $businessPhone
      brokeragePhone: $brokeragePhone
      managingBrokerName: $managingBrokerName
      brokerLicenseNumberAndState: $brokerLicenseNumberAndState
    ) {
      user {
        id
        role
        email
        phone
        firstName
        lastName
        propertyTypes
        specialties
        aboutMe
        brokerName
        brokerageAddress
        facebook
        linkedin
        agentSince
        otherLicenses
        businessPhone
        brokeragePhone
        managingBrokerName
        brokerLicenseNumberAndState
      }
    }
  }
`;

export const UPDATE_USER_PROFILE_LICENCE = gql`
  mutation updateProfile($licence: String) {
    updateProfile(licence: $licence) {
      user {
        licence
      }
    }
  }
`;

export const PLACES_SUGGESTIONS = gql`
  query GetSuggestions($address: String!) {
    places(input: $address) {
      type
      places {
        description
        placeId
      }
    }
  }
`;

export const CREATE_AGENT_LOCATION = gql`
  mutation createAgentLocation($description: String!, $placeId: String!) {
    createAgentLocation(description: $description, placeId: $placeId) {
      agentLocations {
        id
        placeId
        description
      }
    }
  }
`;

export const DELETE_AGENT_LOCATION = gql`
  mutation deleteAgentLocation($id: ID!) {
    deleteAgentLocation(id: $id) {
      status
    }
  }
`;

export const REMOVE_ID_DOCUMENT = gql`
  mutation agentDocuments($id: ID!, $removeFile: Boolean!) {
    agentDocuments(id: $id, removeFile: $removeFile) {
      agentDocument {
        id
      }
    }
  }
`;

export const LEADS_LIST = gql`
  query leadsList($price: [Int!], $address: AddressHash, $page: Int!) {
    leadsList(price: $price, address: $address, page: $page) {
      entities {
        id
        location
        features {
          type
          entities {
            id
            title
            value
          }
        }
        price
        leadPrice
        leadType
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
      filters {
        prices
        propertyTypes
      }
    }
  }
`;

export const LEAD_INFO = gql`
  query leadInfo($id: ID!) {
    leadInfo(id: $id) {
      id
      location
      features {
        type
        entities {
          id
          title
          value
        }
      }
      price
      leadPrice
      leadType
    }
  }
`;

export const CHECK_PURCHASE = gql`
  query checkPurchase($buyerId: ID!, $promoCode: String!) {
    checkPurchase(buyerId: $buyerId, promoCode: $promoCode) {
      needPurchase
      price
      promoCodeDiscount
      pretiisCredits
      total
      notice
    }
  }
`;

export const PURCHASE = gql`
  mutation purchase(
    $buyerId: ID!
    $price: Int!
    $promoCodeDiscount: Float!
    $promoCode: String
    $pretiisCredits: Int!
    $total: Float!
  ) {
    purchase(
      buyerId: $buyerId
      price: $price
      promoCodeDiscount: $promoCodeDiscount
      promoCode: $promoCode
      pretiisCredits: $pretiisCredits
      total: $total
    ) {
      # id
      publishableKey
      clientSecret
    }
  }
`;

export const AGENT_PROFILE = gql`
  query agentProfile($id: ID!) {
    agentProfile(id: $id) {
      userInfo {
        id
        firstName
        lastName
        phone
        email
        avatar
        background
        licence
        aboutMe
        propertyTypes
        soldHouses

        brokerName
        brokerageAddress
        facebook
        linkedin
        agentSince
        otherLicenses
        specialties
        licenceApproved
        businessPhone
        brokeragePhone
        managingBrokerName
        brokerLicenseNumberAndState
        agentLocations {
          id
          description
          placeId
        }
      }
    }
  }
`;

export const DEALS = gql`
  query deals {
    deals {
      entities {
        id
        location
        price
        date
        buyer {
          id
          fullName
          showPublicPage
        }

        state
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation deleteUser {
    deleteUser {
      status
    }
  }
`;

export const PROPERTIES_ANALYTICS = gql`
  query propertiesAnalytics(
    $page: Int!
    $perPage: Int
    $address: AnalyticsLocationInput
    $filters: AnalyticsFiltersInput
  ) {
    propertiesAnalytics(
      page: $page
      address: $address
      filters: $filters
      perPage: $perPage
    ) {
      entities {
        id
        fullAddress
        position {
          lat
          lng
        }
        # latitude
        # longitude
        icon
        likelihoodToSell
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
      filters {
        likelihoodToSell {
          value
          count
        }
      }
      mapOptions {
        zoom
        latitude
        longitude
      }
    }
  }
`;

export const ANALYTICS_PLACE_AUTOCOMPLETE = gql`
  query analyticsPlaceAutocomplete($address: String!) {
    analyticsPlaceAutocomplete(input: $address) {
      type
      zoom
      places {
        description
        type
        placeId
      }
    }
  }
`;

export const TEST_PROPERTIES_ANALYTICS = gql`
  query testPropertiesAnalytics(
    $page: Int!
    $perPage: Int
    $latitude: Float = null
    $longitude: Float = null
    $radius: Float = null
    $address: AnalyticsLocationInput
    $filters: AnalyticsFiltersInput
  ) {
    testPropertiesAnalytics(
      page: $page
      address: $address
      latitude: $latitude
      longitude: $longitude
      radius: $radius
      filters: $filters
      perPage: $perPage
    ) {
      entities {
        label
        radius
        position {
          lat
          lng
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
      filters {
        likelihoodToSell {
          value
          count
        }
      }
      mapOptions {
        zoom
        latitude
        longitude
      }
    }
  }
`;
